import React from 'react';
import {SafeAny} from '@/types';
import {brandName, invitationApplyVisual} from '@/config';
import {
  InvitationApplyFormCard,
  InvitationApplyFormClassNames,
} from './invitation-apply/InvitationApplyFormCard';
import {useInvitationApply} from './invitation-apply/use-invitation-apply';

const formClassNames: InvitationApplyFormClassNames = {
  card: 'relative mx-auto h-full w-full max-w-[21.9375rem]',
  content:
    'absolute left-3 right-3 top-[4.25rem] flex flex-col gap-8 [@media(max-height:54rem)]:top-[3.5rem] [@media(max-height:54rem)]:gap-4',
  error: 'm-0 px-1 text-[0.6875rem] font-normal leading-4 text-[#FF6B57]',
  fields: 'flex flex-col gap-3.5 [@media(max-height:54rem)]:gap-2.5',
  loginButton: 'h-[2.75rem] [@media(max-height:54rem)]:h-[2.5rem]',
  otpField: 'h-[3.125rem] [@media(max-height:54rem)]:h-[2.75rem]',
  phoneField: 'h-[3.125rem] [@media(max-height:54rem)]:h-[2.75rem]',
  phoneWrapper: 'flex flex-col gap-1',
  footer: 'mt-[0.875rem] [@media(max-height:54rem)]:mt-[0.5rem]',
};

const {backgroundSource, brandMark} = invitationApplyVisual;

export function InvitationApply(props: SafeAny) {
  const viewModel = useInvitationApply(props);

  return (
    <main className="relative mx-auto h-[100vh] min-h-0 w-full max-w-[30rem] overflow-hidden bg-[#1A1921] text-white [@media(max-height:54rem)]:overflow-x-hidden [@media(max-height:54rem)]:overflow-y-auto">
      <div className="relative h-full min-h-0 w-full [@media(max-height:54rem)]:min-h-[41.6875rem]">
        <div className="absolute inset-0 bg-[#1A1921]" />
        <img
          src={backgroundSource}
          alt=""
          className="absolute left-0 top-0 h-[32.5rem] w-full object-cover object-top"
        />
        <div className="pointer-events-none absolute left-0 right-0 top-[26rem] h-[9rem] bg-[linear-gradient(180deg,rgba(26,25,33,0)_0%,#1A1921_82%)]" />

        {brandMark.presentation === 'overlay-image' ? (
          <header className="absolute inset-x-0 top-0 z-[1] flex h-[5.5rem] items-end px-3 pb-2">
            <img
              src={brandMark.source}
              alt={brandName}
              className="mb-[1rem] h-[3rem] w-[12.1875rem] object-contain object-left"
            />
          </header>
        ) : null}

        <section className="absolute inset-x-0 bottom-[2.125rem] top-[20rem] z-[1] px-3 [@media(max-height:54rem)]:top-[16rem]">
          <InvitationApplyFormCard
            classNames={formClassNames}
            viewModel={viewModel}
          />
        </section>

        <div className="absolute inset-x-0 bottom-0 z-[1] flex h-[2.125rem] items-center justify-center">
          <span className="h-[0.3125rem] w-[8.375rem] rounded-full bg-[#5E5E5E]" />
        </div>
      </div>
    </main>
  );
}

export default InvitationApply;
